<template>
    <vue-daum-postcode v-if="isInit"
                       @complete="compt"
                       style="max-height: 600px; overflow: auto;"/>
</template>

<script setup>
import {defineEmits, nextTick, onMounted, ref} from "vue";
import {VueDaumPostcode} from "vue-daum-postcode";

const emits = defineEmits(['compt', 'close']);

const compt = ({zonecode: zip, address: adres, sigunguCode: sigunguCd}) => {
  emits('compt', {zip, adres, sigunguCd});
  emits('close');
}

const isInit = ref(false);
onMounted(async () => {
  await nextTick(() => isInit.value = true);
})
</script>

<style scoped>

</style>